import { z } from 'zod';

export const setClipTitleV1ResponseSchema = z.object({
  success: z.literal(true),
  data: z.object({
    clipId: z.number(),
    challengeId: z.number(),
    challengeTitle: z.string(),
    challengeSlug: z.string(),
    sourceSoftDeleted: z.boolean(),
    createdChallenge: z.boolean(),
    baseLocalPath: z.string().nullable(),
    verticalLocalPath: z.string().nullable(),
    basePath: z.string().nullable(),
    verticalPath: z.string().nullable(),
  }),
});

export type ISetClipTitleV1Response = z.infer<typeof setClipTitleV1ResponseSchema>;
